import { lighten, styled } from "@mui/material";
import {InputBase} from '@mui/material';

export const SearchStyle = styled('div')(({ theme, onFocused }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: onFocused ? lighten(theme.palette.secondary.light, 0.3) : lighten(theme.palette.secondary.light, 0.2),
  '&:hover': {
    backgroundColor: lighten(theme.palette.secondary.light, 0.3),
  },
  
  // marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(0),
    width: 'auto',
  },
}));

export const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'primary',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(2em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '15rem',
      '&:focus': {
        width: '20rem',     
      },
    },
  },
}));

